import { Heading } from '@chakra-ui/react'
import React from 'react'

const SubmitPage = () => {
  return (
    <div className='bg-white rounded drop-shadow-2xl p-10'>
        <Heading className="text-center p-10">Your Response has begin Recorded</Heading>
    </div>
  )
}

export default SubmitPage
